import {Text} from 'react-native';
import {useTheme} from 'styled-components';

const SimpleText = props => {
  const theme = useTheme();
  const style1 = {
    fontFamily: 'IRANSans',
    color: props.color
      ? props.color.indexOf('text.') !== -1
        ? theme.colors.text[props.color.replace('text.', '')]
        : theme.colors[props.color]
      : theme.colors.text.base,
  };
  const allStyle = props.style ? {...style1, ...props.style} : style1;

  const textProps = {
    style: allStyle,
  };

  if (props.onPress) textProps.onClick = props.onPress;
  return <Text {...textProps}>{props.text}</Text>;
};

export default SimpleText;
